import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts' 
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale  from "element-plus/lib/locale/lang/zh-cn"
const $ = require('jquery');
window.$ = $;
createApp(App).use(store).use(router).use(echarts).use(ElementPlus,{locale}).mount('#app')
